export class ViewApplicationBpamsApplicationsBpiConstants {
    static STEP_TITLE = "Link building plans applications";
    static REMOVE_LINK_LABEL = "Remove link";
    static LINK_LABEL = "Link";
    static NO_APPLICATIONS_SELECTED = "Please select at least one application";
    static APPLICATIONS_LINKED = "Application links added successfully";
    static APPLICATIONS_DELINKED = "Application links removed successfully";
}
